import { DEFAULT_MAX_QTY } from "../../../models/posm/posm.constant";
import ViewBase from "../../../views/view-base.view";

function QtyNumberInputComponent() {
  ViewBase.call(this);
  return {
    view: ({ attrs: { disabled = false, value = 0, onChange, min = 0, max = DEFAULT_MAX_QTY, placeholder = '', required = false } }) => {
      let maxLength = max.toString().length;
      let invalidQtyText = this.getText("LT00000729", "This field is required")
      let isInvalidQty = () => {
        if (value === '') {
          invalidQtyText = this.getText("LT00000729", "This field is required")
          return true
        }
        if (value > max) {
          invalidQtyText = `${this.getText("LT00000583", "Maximum Value")}: ${max}`
          return true
        }
        if (min > 0 && value <= min - 1) {
          invalidQtyText = `${this.getText("LT00000582", "Minimum Value")} : ${min}`
          return true
        }
        return false
      }
      return [
        m(`input#qty.form-control.form-control-bg.easepick-input${required && isInvalidQty() ? '.is-invalid-custom' : ''}`,
          {
            placeholder,
            disabled,
            required,
            value,
            oninput: (e) => {
              const input = e.target;
              input.value = input.value.match(new RegExp(`[1-9][0-9]{0,${maxLength - 1}}|0{1}|`, 'g'))[0]
              if (parseInt(input.value, 10) > max) {
                if (input.value.length > maxLength)
                  input.value = input.value.slice(0, maxLength)
                else input.value = input.value.slice(0, -1)
              }
              onChange(input.value)
            }
          }
        ),
        m('.invalid-tooltip', invalidQtyText)
      ]
    }
  }
}

export default QtyNumberInputComponent